export const LINKED_IN_URL_FALLBACK =
  'https://linkedin.com/company/goperfect-labs';

export const FORBIDDEN_SUBDOMAIN_NAMES = ['gmail', 'hotmail', 'outlook'];
